export default "__VITE_ASSET__bfe61a51__"